import React from 'react';
import { useSelector } from 'react-redux';
import User from './User';

export default function ManageUsers() {
  const users = useSelector((state) =>
    Object.values(state.users).sort((a, b) => {
      return a.lastName.localeCompare(b.lastName);
    })
  );
  return (
    <div className="users-container scrollable">
      {users.map(
        ({ lastName, firstName, email, id, roles }) =>
          id && (
            <User
              lastName={lastName}
              firstName={firstName}
              key={id}
              userId={id}
              email={email}
              roles={roles}
            />
          )
      )}
    </div>
  );
}
